import React from "react";
import { Navigate } from "react-router-dom";
import { useBranchDefinationContext } from "../context/BranchDefinationContext";

const AuthMiddleware = (props) => {
  const { branchDefinationAlertOpen } = useBranchDefinationContext();

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  /*  UserType: 1 = Employee, 2 = Customer, 3 = Vendor, 4 = Admin, 5 = Appegic Admin  */
  if (!AuthUser) {
    window.location = "/login";
  } else if (props?.path == "dashboard" || props.path == "") {
    // if (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) {

    if (AuthUser?.UserType !== 1 && AuthUser?.UserType !== 2) {
      return (
        <Navigate to={{ pathname: "/home", state: { from: props.location } }} />
      );
    }

    if (AuthUser?.UserType == 2) {
      return (
        <Navigate
          to={{ pathname: "/customer-inward", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "companies") {
    if (AuthUser?.UserType !== 5) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "company-parameters") {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter(
          (x) =>
            x?.FormID == 41 &&
            (x?.IsRead ||
              x?.IsAdd ||
              x?.IsEdit ||
              x?.IsActive ||
              x?.IsDelete ||
              x?.IsExport)
        )?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 41)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "branches") {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter(
          (x) =>
            x?.FormID == 42 &&
            (x?.IsRead ||
              x?.IsAdd ||
              x?.IsEdit ||
              x?.IsActive ||
              x?.IsDelete ||
              x?.IsExport)
        )?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 42)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-branch") {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter((x) => x?.FormID == 42 && x?.IsAdd)?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 42)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-branch/")) {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter((x) => x?.FormID == 42 && x?.IsEdit)?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 42)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-branch-parameters/")) {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter((x) => x?.FormID == 42 && (x?.IsEdit || x?.IsAdd))
          ?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 42)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "application-setup") {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter(
          (x) =>
            x?.FormID == 43 &&
            (x?.IsRead ||
              x?.IsAdd ||
              x?.IsEdit ||
              x?.IsActive ||
              x?.IsDelete ||
              x?.IsExport)
        )?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 43)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "roles") {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter(
          (x) =>
            x?.FormID == 44 &&
            (x?.IsRead ||
              x?.IsAdd ||
              x?.IsEdit ||
              x?.IsActive ||
              x?.IsDelete ||
              x?.IsExport)
        )?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 44)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-roles") {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter((x) => x?.FormID == 44 && x?.IsAdd)?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 44)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-roles/")) {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter((x) => x?.FormID == 44 && x?.IsEdit)?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 44)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "upgrade-licence") {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter(
          (x) =>
            x?.FormID == 45 &&
            (x?.IsRead ||
              x?.IsAdd ||
              x?.IsEdit ||
              x?.IsActive ||
              x?.IsDelete ||
              x?.IsExport)
        )?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 45)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "categories") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 7 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "voucher-series") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 8 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-voucher-series") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 8 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-voucher-series/")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 8 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "employee") {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter(
          (x) =>
            x?.FormID == 9 &&
            (x?.IsRead ||
              x?.IsAdd ||
              x?.IsEdit ||
              x?.IsActive ||
              x?.IsDelete ||
              x?.IsExport)
        )?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 9)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-employee") {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter((x) => x?.FormID == 9 && x?.IsAdd)?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 9)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-employee/")) {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter((x) => x?.FormID == 9 && x?.IsEdit)?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 9)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-user-profile/")) {
    if (AuthUser?.UserType !== 1) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "vendor") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 12 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-vendor") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 12 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-vendor/")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 12 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "courier") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 13 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-courier") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 13 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-courier/")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 13 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "customer") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 10 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("add-customer")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 10 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-customer/")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 10 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "material-categories") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 17 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "departments") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 18 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-department") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 18 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-department/")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 18 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "product-groups") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 19 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-product-group") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 19 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-product-group/")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 19 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "test-method") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 20 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-test-method") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 20 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-test-method/")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 20 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "parameters") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 21 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-parameter") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 21 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-parameter/")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 21 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "test-master") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 22 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-test-master") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 22 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-test-master/")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 22 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "reference-standard") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 23 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-reference-standard") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 23 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-reference-standard/")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 23 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "reference-standard-test-mapping") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 24 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-reference-standard-test-mapping") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 24 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-reference-standard-test-mapping/")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 24 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("copy-reference-standard-test-mapping/")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 24 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "machines") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 25 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-machines") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 25 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-machines/")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 25 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "machines-calibration") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 26 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-machines-calibration") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 26 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-machines-calibration/")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 26 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "machine-configuration-list") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 16 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-machine-configuration") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 16 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-machine-configuration/")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 16 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (
    props?.path == "material-inward" ||
    props?.path?.includes("copy-material-inward/")
  ) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.DT !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 31 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-material-inward") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.DT !== 1 ||
      formsList?.filter((x) => x?.FormID == 31 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-material-inward/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.DT !== 1 ||
      formsList?.filter((x) => x?.FormID == 31 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "tc-test-allocation-list") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 32 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("tc-test-allocation/")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 32 && (x?.IsAdd || x?.IsEdit))
        ?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("view-material-inward/")) {
    if (
      (AuthUser?.UserType !== 1 && AuthUser?.UserType !== 2) ||
      AuthUser?.Permissions?.DT !== 1 ||
      formsList?.filter((x) => x?.FormID == 31 && x?.IsRead)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("add-inward-approval/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.IsInwardApprover == false ||
      AuthUser?.Permissions?.ApprovalWorkflow !== 1
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "testing-list") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 33 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("testing/:InwardMaterialIDParam")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 33 && (x?.IsAdd || x?.IsEdit))
        ?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "report-printing-list") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 34 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("add-report-printing/")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 34 && (x?.IsAdd || x?.IsEdit))
        ?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "upload-scan-copy-list") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.UploadScanCopy !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 37 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-upload-scan-copy") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.UploadScanCopy !== 1 ||
      formsList?.filter((x) => x?.FormID == 37 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-upload-scan-copy/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.UploadScanCopy !== 1 ||
      formsList?.filter((x) => x?.FormID == 37 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "machining-outward-list") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Machining !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 28 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-machining-outward") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Machining !== 1 ||
      formsList?.filter((x) => x?.FormID == 28 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-machining-outward/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Machining !== 1 ||
      formsList?.filter((x) => x?.FormID == 28 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("add-machining-inward/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Machining !== 1 ||
      formsList?.filter((x) => x?.FormID == 28 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "report-dispatch-list") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.DispatchReport !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 35 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("add-report-dispatch/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.DispatchReport !== 1 ||
      formsList?.filter((x) => x?.FormID == 35 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-report-dispatch/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.DispatchReport !== 1 ||
      formsList?.filter((x) => x?.FormID == 35 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "material-dispatch-list") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.DispatchMaterial !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 36 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("add-material-dispatch/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.DispatchMaterial !== 1 ||
      formsList?.filter((x) => x?.FormID == 36 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-material-dispatch/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.DispatchMaterial !== 1 ||
      formsList?.filter((x) => x?.FormID == 36 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "reports") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 30 && x?.IsRead)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "inward-register") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 30 && x?.IsRead)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "process-status") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 30 && x?.IsRead)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "dispatch-report") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.DispatchReport !== 1 ||
      formsList?.filter((x) => x?.FormID == 30 && x?.IsRead)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "dispatch-material") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 30 && x?.IsRead)?.length == 0 ||
      AuthUser?.Permissions?.DispatchMaterial !== 1
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "pending-testing") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 30 && x?.IsRead)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "chat-history") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 30 && x?.IsRead)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "master-data-import") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 46 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "print-label") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 38 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "broadcast-message") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Email !== 1 ||
      formsList?.filter((x) => x?.FormID == 39 && x?.IsRead)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "test-master-rate") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 48 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "customer-parameter-rate") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 49 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "proforma-invoice") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 51 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-proforma-invoice") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 51 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-proforma-invoice/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 51 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "invoice") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 52 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-invoice") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 52 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-invoice/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 52 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "expenses") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 53 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-expenses") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 53 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-expenses/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 53 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "advance-receipt") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 54 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-advance-receipt") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 54 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-advance-receipt/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 54 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "payment-receipt") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 55 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-payment-receipt") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 55 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-payment-receipt/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 55 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "outstanding-report") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 57 && (x?.IsRead || x?.IsExport))
        ?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "invoice-register") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 58 && (x?.IsRead || x?.IsExport))
        ?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "pending-invoice") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 59 && (x?.IsRead || x?.IsExport))
        ?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "payment-receipt-register") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 60 && (x?.IsRead || x?.IsExport))
        ?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "email-configuration") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Email !== 1 ||
      formsList?.filter(
        (x) => x?.FormID == 61 && (x?.IsRead || x?.IsAdd || x?.IsEdit)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "whatsapp-configuration") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) => x?.FormID == 81 && (x?.IsRead || x?.IsAdd || x?.IsEdit)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "company-lut-document") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 83 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-company-lut-document") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 83 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-company-lut-document/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 83 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "ledger-report") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 62 && (x?.IsRead || x?.IsExport))
        ?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "credit-note") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 63 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-credit-note") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 63 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-credit-note/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Account !== 1 ||
      formsList?.filter((x) => x?.FormID == 63 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "customer-inward") {
    if (AuthUser?.UserType !== 2) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "customer-invoice") {
    if (AuthUser?.UserType !== 2) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "customer-ledger-report") {
    if (AuthUser?.UserType !== 2) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "customer-outstanding-report") {
    if (AuthUser?.UserType !== 2) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "email-templates-edit") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Email !== 1 ||
      formsList?.filter((x) => x?.FormID == 79 && (x?.IsRead || x?.IsEdit))
        ?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "machine-result-csv-file-import") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 80 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "update-scope") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 85 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "document-management") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 87 &&
          (x?.IsRead || x?.IsAdd || x?.IsEdit || x?.IsActive || x?.IsDelete)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-document-management") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 87 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-document-management/")) {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter((x) => x?.FormID == 87 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "mix-design-master") {
    if (
      AuthUser?.UserType !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 82 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "sample-preparation-and-testing") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.LicenseTypeID != 5 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 88 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-sample-preparation-and-testing") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.LicenseTypeID != 5 ||
      formsList?.filter((x) => x?.FormID == 88 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-sample-preparation-and-testing/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.LicenseTypeID != 5 ||
      formsList?.filter((x) => x?.FormID == 88 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("view-sample-preparation-and-testing/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.LicenseTypeID != 5 ||
      formsList?.filter((x) => x?.FormID == 88 && x?.IsRead)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "nabl-scope") {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter(
          (x) =>
            x?.FormID == 84 &&
            (x?.IsRead ||
              x?.IsAdd ||
              x?.IsEdit ||
              x?.IsActive ||
              x?.IsDelete ||
              x?.IsExport)
        )?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 84)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-nabl-scope") {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter((x) => x?.FormID == 84 && x?.IsAdd)?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 84)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-nabl-scope/")) {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter((x) => x?.FormID == 84 && x?.IsEdit)?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 84)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "logo-validity") {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter(
          (x) =>
            x?.FormID == 86 &&
            (x?.IsRead ||
              x?.IsAdd ||
              x?.IsEdit ||
              x?.IsActive ||
              x?.IsDelete ||
              x?.IsExport)
        )?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 86)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "items") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 90 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-items") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter((x) => x?.FormID == 90 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-items/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter((x) => x?.FormID == 90 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "item-wastage") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 98 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-item-wastage") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter((x) => x?.FormID == 98 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-item-wastage/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter((x) => x?.FormID == 98 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "item-dc") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 99 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-item-dc") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter((x) => x?.FormID == 99 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-item-dc/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter((x) => x?.FormID == 99 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "grn") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 91 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-grn") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter((x) => x?.FormID == 91 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-grn/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter((x) => x?.FormID == 91 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("view-grn/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter((x) => x?.FormID == 91 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "films") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.NDT !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 95 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-films") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.NDT !== 1 ||
      formsList?.filter((x) => x?.FormID == 95 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-films/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.NDT !== 1 ||
      formsList?.filter((x) => x?.FormID == 95 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "ndt-categories") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.NDT !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 94 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "camera") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.NDT !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 96 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-camera") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.NDT !== 1 ||
      formsList?.filter((x) => x?.FormID == 96 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-camera/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.NDT !== 1 ||
      formsList?.filter((x) => x?.FormID == 96 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "ndtmaterial") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.NDT !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 104 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-ndtmaterial") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.NDT !== 1 ||
      formsList?.filter((x) => x?.FormID == 104 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-ndtmaterial/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.NDT !== 1 ||
      formsList?.filter((x) => x?.FormID == 104 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "supplier") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.NDT !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 97 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-supplier") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.NDT !== 1 ||
      formsList?.filter((x) => x?.FormID == 97 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-supplier/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.NDT !== 1 ||
      formsList?.filter((x) => x?.FormID == 97 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "item-issue") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 92 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-item-issue") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter((x) => x?.FormID == 92 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "item-return") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 93 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-item-return") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter((x) => x?.FormID == 93 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "add-logo-validity") {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter((x) => x?.FormID == 86 && x?.IsAdd)?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 86)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-logo-validity/")) {
    if (
      (AuthUser?.UserType !== 4 && AuthUser?.UserType !== 1) ||
      (AuthUser?.UserType == 1 &&
        formsList?.filter((x) => x?.FormID == 86 && x?.IsEdit)?.length == 0) ||
      (AuthUser?.UserType == 4 &&
        formsList?.filter((x) => x?.FormID == 86)?.length == 0)
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "item-stock-register") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter((x) => x?.FormID == 101 && (x?.IsRead || x?.IsExport))
        ?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "item-issue-in-out") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.Inventory !== 1 ||
      formsList?.filter((x) => x?.FormID == 102 && (x?.IsRead || x?.IsExport))
        ?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path == "ndt-material-inward") {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.NDT !== 1 ||
      formsList?.filter(
        (x) =>
          x?.FormID == 103 &&
          (x?.IsRead ||
            x?.IsAdd ||
            x?.IsEdit ||
            x?.IsActive ||
            x?.IsDelete ||
            x?.IsExport)
      )?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (
    props?.path == "add-ndt-material-inward" ||
    props?.path?.includes("copy-ndt-material-inward/")
  ) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.NDT !== 1 ||
      formsList?.filter((x) => x?.FormID == 103 && x?.IsAdd)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("edit-ndt-material-inward/")) {
    if (
      AuthUser?.UserType !== 1 ||
      AuthUser?.Permissions?.NDT !== 1 ||
      formsList?.filter((x) => x?.FormID == 103 && x?.IsEdit)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  } else if (props?.path?.includes("view-ndt-material-inward/")) {
    if (
      (AuthUser?.UserType !== 1 && AuthUser?.UserType !== 2) ||
      AuthUser?.Permissions?.NDT !== 1 ||
      formsList?.filter((x) => x?.FormID == 103 && x?.IsRead)?.length == 0
    ) {
      return (
        <Navigate
          to={{ pathname: "/dashboard", state: { from: props.location } }}
        />
      );
    }
  }

  /* If branch definition is not set then do not allow to do transaction. */
  if (AuthUser?.IsBranchDefinationComplate == false) {
    if (
      props?.path == "material-inward" ||
      props?.path == "add-material-inward" ||
      props?.path?.includes("edit-material-inward/") ||
      props?.path == "tc-test-allocation-list" ||
      props?.path?.includes("tc-test-allocation/") ||
      props?.path?.includes("add-inward-approval/") ||
      props?.path == "testing-list" ||
      props?.path?.includes("testing/:InwardMaterialIDParam") ||
      props?.path == "report-printing-list" ||
      props?.path?.includes("add-report-printing/") ||
      props?.path == "upload-scan-copy-list" ||
      props?.path == "add-upload-scan-copy" ||
      props?.path?.includes("edit-upload-scan-copy/") ||
      props?.path == "machining-outward-list" ||
      props?.path == "add-machining-outward" ||
      props?.path?.includes("edit-machining-outward/") ||
      props?.path?.includes("add-machining-inward/") ||
      props?.path == "report-dispatch-list" ||
      props?.path?.includes("add-report-dispatch/") ||
      props?.path?.includes("edit-report-dispatch/") ||
      props?.path == "material-dispatch-list" ||
      props?.path?.includes("add-material-dispatch/") ||
      props?.path?.includes("edit-material-dispatch/") ||
      props?.path == "reports" ||
      props?.path == "inward-register" ||
      props?.path == "process-status" ||
      props?.path == "dispatch-report" ||
      props?.path == "dispatch-material" ||
      props?.path == "pending-testing" ||
      props?.path == "chat-history" ||
      props?.path == "proforma-invoice" ||
      props?.path == "add-proforma-invoice" ||
      props?.path?.includes("edit-proforma-invoice/") ||
      props?.path == "invoice" ||
      props?.path == "add-invoice" ||
      props?.path?.includes("edit-invoice/") ||
      props?.path == "advance-receipt" ||
      props?.path == "add-advance-receipt" ||
      props?.path?.includes("edit-advance-receipt/") ||
      props?.path == "payment-receipt" ||
      props?.path == "add-payment-receipt" ||
      props?.path?.includes("edit-payment-receipt/") ||
      props?.path == "outstanding-report" ||
      props?.path == "invoice-register" ||
      props?.path == "pending-invoice" ||
      props?.path == "payment-receipt-register" ||
      props?.path == "ledger-report" ||
      props?.path == "credit-note" ||
      props?.path == "add-credit-note" ||
      props?.path == "company-lut-document" ||
      props?.path == "add-company-lut-document" ||
      props?.path?.includes("edit-credit-note/") ||
      props?.path == "sample-preparation-and-testing" ||
      props?.path == "add-sample-preparation-and-testing" ||
      props?.path?.includes("edit-sample-preparation-and-testing/") ||
      props?.path?.includes("view-sample-preparation-and-testing/") ||
      props?.path == "ndt-material-inward" ||
      props?.path == "add-ndt-material-inward" ||
      props?.path?.includes("edit-ndt-material-inward/")
    ) {
      branchDefinationAlertOpen();
      return (
        <Navigate
          to={{
            pathname: `/edit-branch/${window.btoa(AuthUser?.BranchIDEncrypt)}`,
            state: { from: props.location },
          }}
        />
      );
    }
  }

  return (
    <React.Fragment>
      <div>{props.children}</div>
    </React.Fragment>
  );
};
export default AuthMiddleware;
